import { render, staticRenderFns } from "./SelectedTagsList.vue?vue&type=template&id=0e4118c4&scoped=true&"
import script from "./SelectedTagsList.vue?vue&type=script&lang=ts&"
export * from "./SelectedTagsList.vue?vue&type=script&lang=ts&"
import style0 from "./SelectedTagsList.vue?vue&type=style&index=0&id=0e4118c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4118c4",
  null
  
)

export default component.exports